<template>
    <div class="loginWrap">
        <div class="myIcon" @click="$emit('openLogin')" >
            <font-awesome-icon class="icon" icon="times"/>
        </div>
        <form>
        <h3>Reset your password</h3>
        <input type="email" placeholder="Enter your e-mail">
            <input class="form-input" @click.prevent="sendNewPassword" value="Send new password" type="submit">
        </form>
    </div>

</template>

<script>
    export default {
        name: "forgotPassword",
        methods: {
            sendNewPassword() {
                return console.log('pass sent');
            }
        }
    }

</script>

<style scoped>

</style>